var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c(
            "keep-alive",
            [
              _vm.currentView
                ? _c(_vm.currentView.type, {
                    key: _vm.currentView.id,
                    tag: "component",
                    attrs: {
                      ticket: _vm.ticket,
                      attachments: _vm.attachments,
                      step: _vm.currentView,
                    },
                    on: {
                      loadTicket: _vm.loadTicket,
                      goto: _vm.setStep,
                      changeView: _vm.changeView,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }